import { FC } from 'react';
import { Container, Box } from '@mui/material';
import { RegisterForm } from '@/components/Auth';

export const RegisterPage: FC = () => {
  return (
    <Container component="main" maxWidth="xs" disableGutters>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '80vh',
          justifyContent: 'center',
        }}
      >
        <RegisterForm />
      </Box>
    </Container>
  );
};
